<div class="product-info-mobile-preview">
  <div class="info-bar">
    <h1>
      @if (ProgramData()) {
        @if (Episode()) {
          {{ ProgramData().program.title }}
          {{ ProgramData().seasons.length > 1 ? handleSeasonTitle() + " " + Episode()?.title : Episode()?.title }}
        } @else {
          {{ ProgramData().program.title }}
        }
      }
    </h1>
    <div class="product-info">
      <div class="product-genres">
        @for (item of ProgramData().genres.slice(0, 2); track $index) {
          <a routerLink="/g/{{ item?.descriptor }}">{{ item?.name }}</a>
          <span class="tag-separator">،</span>
        }
      </div>
      <div class="product-metadata">
        <h3>
          @if (ProgramData().program.statisticsDetails) {
            {{
              ProgramData().program.statisticsDetails.totalLikePercentage +
                ProgramData().program.statisticsDetails.totalLovePercentage
            }}٪ پسندیدند
          }
        </h3>
        <span class="production-year">{{ ProgramData().program.productionYear }}</span>
        <!-- <app-icon-button [IsButton]="true" Icon="subtitles" Appearance="default" [WithTooltip]="true" TooltipText="زیرنویس" /> -->
        <app-icon-button Icon="hd" Appearance="default" [WithTooltip]="true" TooltipText="کیفیت HD" [IsButton]="true" />
        <span class="production-year">{{ ProgramData().program.parentalGuidance }}</span>
      </div>
    </div>
  </div>
  <div class="product-info-operation-buttons">
    @if (ProgramData()) {
      @if (ProgramHasCopyright()) {
        <app-button
          class="play-btn"
          Text="در لوکیشن شما در دسترس نیست"
          Icon="public_off"
          Appearance="warning"
          [FullWidth]="true"
        />
      } @else {
        @if (tokenService.userInfo()) {
          @if (Episode()) {
            @if (Episode()!.releaseStatus === episodeReleaseStatus.Released) {
              @if (programService.canWatchInSiteProgram(Episode()!)) {
                <app-button
                  (Click)="handlePlay()"
                  [IsFillIcon]="true"
                  Icon="play_arrow"
                  Text="تماشا"
                  Appearance="secondary"
                  class="play-btn"
                  [FullWidth]="true"
                  [IsButton]="true"
                />
              } @else {
                <app-button [FullWidth]="true" class="play-btn" Text="خرید اشتراک" Icon="shop" Link="/account/plans" />
              }
            } @else if (Episode()?.releaseStatus === episodeReleaseStatus.ComingSoon) {
              <app-button
                [IsButton]="true"
                Icon="schedule"
                Text="به زودی"
                class="play-btn"
                Appearance="accent"
                [FullWidth]="true"
              />
            } @else {
              <app-countdown-release [ReleaseDate]="ProgramData().solitaryEpisode?.releaseDate" />
            }
          } @else {
            @if (ProgramData().solitaryEpisode?.releaseStatus === episodeReleaseStatus.Released) {
              @if (programService.canWatchInSiteProgram(ProgramData().solitaryEpisode!)) {
                <app-button
                  [IsButton]="true"
                  (Click)="handlePlay()"
                  [IsFillIcon]="true"
                  Icon="play_arrow"
                  Text="تماشا"
                  Appearance="secondary"
                  class="play-btn"
                  [FullWidth]="true"
                />
              } @else {
                <app-button [FullWidth]="true" class="play-btn" Text="خرید اشتراک" Icon="shop" Link="/account/plans" />
              }
            } @else if (ProgramData().solitaryEpisode?.releaseStatus === episodeReleaseStatus.ComingSoon) {
              <app-button
                [IsButton]="true"
                Icon="schedule"
                Text="به زودی"
                class="play-btn"
                Appearance="accent"
                [FullWidth]="true"
              />
            } @else {
              <app-countdown-release [ReleaseDate]="ProgramData().solitaryEpisode?.releaseDate" />
            }
          }
        } @else {
          <app-button
            [IsButton]="true"
            (Click)="handleLoginAndWatch()"
            [IsFillIcon]="true"
            [FullWidth]="true"
            Icon="play_arrow"
            Text="ورود و تماشا"
            class="play-btn"
            Appearance="secondary"
          />
        }
      }
    } @else {
      <app-button
        [IsButton]="true"
        (Click)="handleLoginAndWatch()"
        [IsFillIcon]="true"
        Icon="play_arrow"
        Text="ورود و تماشا"
        class="play-btn"
        Appearance="secondary"
        [FullWidth]="true"
      />
    }

    <div class="product-extra-operation-buttons">
      @if (tokenService.userInfo()) {
        @if (!Episode()) {
          <button mat-flat-button (click)="toggleBookmarkProgram()">
            <span class="operation-title">لیست تماشا</span>
            <mat-icon [fontSet]="programBookmarked() ? 'mat-symbol-round-fill' : 'mat-symbol-round'">bookmark</mat-icon>
          </button>
        }
        <div class="interest-btn">
          <button mat-flat-button (click)="isShowDllBox.set(!isShowDllBox())">
            <span class="operation-title">{{
              isShowDllBox()
                ? "بستن"
                : selectedInterest() === null
                  ? "امتیاز دادن"
                  : selectedInterest() && selectedInterest() === interestAction.Dislike
                    ? "نپسندیدم"
                    : selectedInterest() && selectedInterest() === interestAction.Love
                      ? "عاشقشم"
                      : "پسندیدم"
            }}</span>
            <mat-icon [fontSet]="selectedInterest() !== null ? 'mat-symbol-round-fill' : 'mat-symbol-round'">{{
              isShowDllBox()
                ? "close"
                : selectedInterest() && selectedInterest() === interestAction.Dislike
                  ? "thumb_down"
                  : selectedInterest() && selectedInterest() === interestAction.Love
                    ? "favorite"
                    : "thumb_up"
            }}</mat-icon>
          </button>
          @if (isShowDllBox()) {
            <div class="interest-box">
              <div class="dll-opened-box">
                <button mat-flat-button (click)="handleInterestAction(interestAction.Love)">
                  <mat-icon
                    [fontSet]="
                      selectedInterest() !== null && selectedInterest() === interestAction.Love
                        ? 'mat-symbol-round-fill'
                        : 'mat-symbol-round'
                    "
                    >favorite</mat-icon
                  >
                  <span>عاشقشم</span>
                </button>
                <button mat-flat-button (click)="handleInterestAction(interestAction.Like)">
                  <mat-icon
                    [fontSet]="
                      selectedInterest() !== null && selectedInterest() === interestAction.Like
                        ? 'mat-symbol-round-fill'
                        : 'mat-symbol-round'
                    "
                    >thumb_up</mat-icon
                  >
                  <span>پسندیدم</span>
                </button>
                <button mat-flat-button (click)="handleInterestAction(interestAction.Dislike)">
                  <mat-icon
                    [fontSet]="
                      selectedInterest() !== null && selectedInterest() === interestAction.Dislike
                        ? 'mat-symbol-round-fill'
                        : 'mat-symbol-round'
                    "
                    >thumb_down</mat-icon
                  >
                  <span>نپسندیدم</span>
                </button>
              </div>
            </div>
          }
        </div>
        <button mat-flat-button (click)="shareItem()">
          <span class="operation-title">اشتراک گذاری</span>
          <mat-icon>share</mat-icon>
        </button>
      } @else {
        <button mat-flat-button (click)="shareItem()">
          <span class="operation-title">اشتراک گذاری</span>
          <mat-icon>share</mat-icon>
        </button>
      }
    </div>
    <div class="product-casts">
      @for (item of ProgramData().cast; track item) {
        @if (item?.role === "DIRECTOR") {
          <div class="product-cast-item">
            <span class="tag-title">{{ item?.name }}: </span>
            @if (item?.artists) {
              @for (artist of item?.artists; track artist; let j = $index) {
                <a class="tag-data-name" routerLink="/a/{{ artist?.descriptor }}">
                  <span>{{ artist?.fullName }}</span>
                  @if (item && item.artists && j < item.artists.length - 1) {
                    <span class="item-separator">،</span>
                  }
                </a>
              }
            }
          </div>
        }
        @if (item?.role === "PERFORMER") {
          <div class="product-cast-item">
            <span class="tag-title">{{ item?.name }}: </span>
            @for (artist of item?.artists; track artist; let j = $index) {
              @if (j < 2) {
                <a class="tag-data-name" routerLink="/a/{{ artist?.descriptor }}">
                  <span>{{ artist?.fullName }}</span>
                  @if (j < 1) {
                    <span class="item-separator">،</span>
                  }
                </a>
              }
            }
            <app-icon-button
              [IsButton]="true"
              class="navigate-about"
              Appearance="default"
              Icon="expand_more"
              (Click)="handleNavigateToAboutSection()"
            />
          </div>
        }
      }
    </div>
    <p class="product-summary">
      @if (Episode()) {
        {{ Episode()!.summary | slice: 0 : showSummaryLength() }}
      } @else {
        {{ ProgramData().program.summary | slice: 0 : showSummaryLength() }}
      }
      <button class="show-more-summary" mat-flat-button (click)="handleShowMoreSummary()">
        <span>
          <span>نمایش </span>
          <span>{{ summaryLength() > showSummaryLength() ? "بیشتر" : "کمتر" }}</span>
        </span>
      </button>
    </p>
  </div>
</div>
